module.exports = __webpack_public_path__ + "img/视频.dc20ac57.svg";